import React from 'react';

import { Redirect } from 'react-router-dom';
import * as constants from 'app-constants';

export default function index() {
  return <Redirect to={constants.PATH_APPLICATIONS} />;
}
